// extracted by mini-css-extract-plugin
module.exports = {"noop":"Checkbox_noop__IjDF1","checkbox":"Checkbox_checkbox__2kVOT","icon":"Checkbox_icon__2kNZ2","whiteBackground":"Checkbox_whiteBackground__1NOri"};